import Commons from '@features/shared/libraries/commons';
import { FcmNotification } from '@features/shared/libraries/fcmNotification';

class NotificationService {
  async getDeviceToken() {
    let token = null;
    if (Commons.isCapacitor()) {
      token = await this.getCapacitorDeviceToken();
    } else if ('Notification' in window) {
      await FcmNotification.init();
      try {
        const perm = await Notification.requestPermission();
        if (perm === 'granted') {
          token = await FcmNotification.getDeviceToken();
        }
      } catch (e) {
        console.error(e);
      }
    }
    console.log('🚀 ~ NotificationService ~ getDeviceToken ~ token:', token);
    return token;
  }
  async getCapacitorDeviceToken() {
    return new Promise((resolve) => {
      const requestId = Commons.generateUUID();
      const responseHandler = (event) => {
        if (
          event.data?.type === 'DEVICE_TOKEN_RESPONSE' &&
          event.data.requestId === requestId
        ) {
          window.removeEventListener('message', responseHandler);
          resolve(event.data.token);
        }
      };

      window.addEventListener('message', responseHandler);

      try {
        window.parent.postMessage(
          {
            type: 'REQUEST_DEVICE_TOKEN',
            requestId: requestId
          },
          '*'
        );
      } catch (error) {
        window.removeEventListener('message', responseHandler);
        console.log('🚀 ~ Commons ~ getDeviceToken ~ error:', error);
        resolve(null);
      }

      // Timeout après 3 secondes
      setTimeout(() => {
        window.removeEventListener('message', responseHandler);
        resolve(null);
      }, 3000);
    });
  }

  async uploadDeviceToken(userId, token) {
    if (!userId || !token) return;

    const requestId = `device-token-${Date.now().toString(36)}${Math.floor(Math.random() * 100000)}`;

    const payload = {
      token: token,
      userId: userId,
      requestId,
      service: 'rapidoo'
    };

    console.log('[NotificationService] Uploading device token...', payload);

    fetch(
      'https://api.monrapidoo.com/queue/broadcast/data/rapidoo-transactions/addToken?group=commons',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }
    ).catch((err) => {
      console.error('[NotificationService] uploadDeviceToken error:', err);
    });
  }
}

export const notificationService = new NotificationService();
